import * as PIXI from 'pixi.js';
import { Signal } from 'framework/utils/Signal';

const originalDestroy = PIXI.DisplayObject.prototype.destroy;

PIXI.DisplayObject.prototype.destroy = function destroy() {
  if (this._onDestroyed) {
    this._onDestroyed.dispatch();
    this._onDestroyed.removeAll();
  }

  if (this._onReleased) {
    this._onReleased.removeAll();
  }

  originalDestroy.call(this);
};

PIXI.DisplayObject.prototype.props = function props(props) {
  if (props.position) {
    const {x, y} = props.position;
    this.position.set(x, y);
  }

  if (props.scale !== undefined) {
    if (typeof props.scale === 'number') {
      this.scale.set(props.scale, props.scale);
    } else {
      const {x, y} = props.scale;
      this.scale.set(x, y); 
    }
  }

  if (props.pivot !== undefined) {
    if (typeof props.pivot === 'number') {
      this.pivot.set(props.pivot, props.pivot);
    } else {
      const {x, y} = props.pivot;
      this.pivot.set(x, y); 
    }
  }

  if (props.visible !== undefined) this.visible = props.visible;
  if (props.alpha !== undefined) this.alpha = props.alpha;
  if (props.x !== undefined) this.x = props.x;
  if (props.y !== undefined) this.y = props.y;
  if (props.scaleX !== undefined) this.scaleX = props.scaleX;
  if (props.scaleY !== undefined) this.scaleY = props.scaleY;
  if (props.angle !== undefined) this.angle = props.angle;
  if (props.rotation !== undefined) this.rotation = props.rotation;
  if (props.parent) props.parent.addChild(this);

  return this;
};

PIXI.Sprite.prototype.props = function props(props) {
  PIXI.DisplayObject.prototype.props.call(this, props);

  if (props.anchor !== undefined) {
    if (typeof props.anchor === 'number') {
      this.anchor.set(props.anchor, props.anchor);
    } else {
      const {x, y} = props.anchor;
      this.anchor.set(x, y); 
    }
  }

  if (props.texture !== undefined) {
    if (typeof props.texture === 'string') {
      this.texture = PIXI.Texture.from(props.texture);
    } else {
      this.texture = props.texture;
    }
  }

  if (props.tint !== undefined) this.tint = props.tint;
  if (props.blendMode !== undefined) this.blendMode = props.blendMode;
  if (props.width !== undefined) this.width = props.width;
  if (props.height !== undefined) this.height = props.height;

  return this;
};

Object.defineProperty(PIXI.DisplayObject.prototype, 'destroyed', {
  get() {
    return this._destroyed;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'onDestroyed', {
  get() {
    if (!this._onDestroyed) {
      this._onDestroyed = new Signal<void>();
      this._onDestroyed.memorize = true;
      if (this.destroyed) this._onDestroyed.dispatch();
      if (this._onReleased) this._onReleased = new Signal<void>();
    }
    return this._onDestroyed;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'onReleased', {
  get() {
    if (!this._onReleased) this._onReleased = new Signal<void>();
    return this._onReleased;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'angle', {
  set(v) {
    this.rotation = (v / 180) * Math.PI;
  },
  get() {
    return (this.rotation / Math.PI) * 180;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'scaleX', {
  set(v) {
    this.scale.x = v;
  },
  get() {
    return this.scale.x;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'scaleY', {
  set(v) {
    this.scale.y = v;
  },
  get() {
    return this.scale.y;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'regX', {
  set(v) {
    this.pivot.x = v;
  },
  get() {
    return this.pivot.x;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'regY', {
  set(v) {
    this.pivot.y = v;
  },
  get() {
    return this.pivot.y;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'skewX', {
  set(v) {
    this.skew.x = v;
  },
  get() {
    return this.skew.x;
  },
});

Object.defineProperty(PIXI.DisplayObject.prototype, 'skewY', {
  set(v) {
    this.skew.y = v;
  },
  get() {
    return this.skew.y;
  },
});
